import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
  ViewChild,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { Chart } from 'chart.js/auto';
import { GroupMember } from '@interface/Dealer';
import { skip, Subject, takeUntil } from 'rxjs';
import { GlobalService } from '@core/services/global/global.service';
import { KeyGraphService } from '@core/services/KeyGraph/key-graph.service';
import { drowdownValues, keygraphRequest } from '@interface/keygraph';
import { DownloadType } from '@enums/DownloadType';
import { PdfViewerService } from '@core/services/pdf/pdf-viewer.service';
import { Router } from '@angular/router';
import { PdfButtonClickedEvent } from '@interface/IPdfGeneration';
import { PopupComponent } from '@shared/components/popup/popup.component';
import { ExcelpdfpopupComponent } from '@shared/components/excelpdfpopup/excelpdfpopup.component';
import { CustomDropdownComponent } from '@shared/components/custom-dropdown/custom-dropdown.component';
import { GroupComposite, monthYearDTOs } from '@interface/vitals';
import { BarChartComponent } from '@shared/components/bar-chart/bar-chart.component';
import { FormsModule } from '@angular/forms';
import { ErrorPageComponent } from '@shared/components/app-error-page/app-error-page.component';
import { BaseErrorComponent } from '../baseerror/baseerror.component';
import { CommentsService } from '@core/services/comments/comments.service';
@Component({
  selector: 'app-key-graph',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ExcelpdfpopupComponent,
    CustomDropdownComponent,
    BarChartComponent,
    ErrorPageComponent,
    PopupComponent,
  ],
  templateUrl: './key-graph.component.html',
  styleUrl: './key-graph.component.css',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KeyGraphComponent
  extends BaseErrorComponent
  implements OnInit, OnDestroy
{
  private readonly unsubscribe$ = new Subject<void>();
  @ViewChild('pdfExcelPopup') pdfExcelPopup!: ExcelpdfpopupComponent;
  keygraphData: any[] = [];
  keyGraphDateDropDownData: drowdownValues[] = [];
  monthOptions: string[] = [];
  selectedGraph: any[] = [];
  period?: monthYearDTOs;
  graph?: number;
  selectedDealer: GroupMember | null = null;
  groupId: number | null = null;
  selectedList: any[] = [];
  dateDropDownData: monthYearDTOs[] = [];
  selectedDropDownValue!: GroupComposite;
  selectedMonthYear: any;
  modalMessage: string = '';
  message?: '';
  public charts: { [key: string]: Chart } = {}; // Store chart instances
  mode: 'excel' | 'pdf' = 'excel';
  showExcelPdfPopUp = false;
  popupTitle: string = 'Keygraph';
  reportTitle: string = 'Keygraph Dashboard';
  isPageLayoutEnabled: boolean = false; // Track page layout toggle
  pdfOptions = [
    { label: 'N20 Header', checked: true },
    { label: 'Keygraph Chart', checked: true },
  ];
  selectedOptions: string[] = [];
  isLoading = false;
  showNoData: boolean = false;
  tempSelectedList: number[] = [];
  previousTempSelectedList: number[] = []; // The current working selection in the dropdown
  selectedCharts: drowdownValues[] = [];

  primaryChartColor: string = '';
  secondaryChartColor: string = '';
  whiteColor: string = '';
  blackColor: string = '';
  dropDownData: GroupComposite[] = [];
  dateDropdownData: GroupComposite[] = [];
  selectedGroupCompositeId: any;
  dataChamged: boolean = true;

  showPdfExportMessage: boolean = false;
  pdfExportMessage: string = '';

  constructor(
    private keyGraphService: KeyGraphService,
    private globalService: GlobalService,
    private commentService: CommentsService,
    private cdr: ChangeDetectorRef,
    private readonly pdfViewerService: PdfViewerService,
    private router: Router,
  ) {
    super();
  }

  async ngOnInit() {
    this.primaryChartColor = this.globalService.getCSSVariable(
      '--primary-chart-color',
    );
    this.secondaryChartColor = this.globalService.getCSSVariable(
      '--secondary-chart-color',
    );
    this.whiteColor = this.globalService.getCSSVariable('--white-color');
    this.blackColor = this.globalService.getCSSVariable('--black-color');

    this.globalService.selectedDealer$
      .pipe(takeUntil(this.unsubscribe$), skip(1))
      .subscribe(async (dealer) => {
        this.selectedDealer = dealer;
        await this.globalService.fetchDateDropdownData();
        if (this.selectedDropDownValue && this.selectedCharts.length)
          this.KeyGraphDropdownData();
      });

    this.globalService.dateDropdownData$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(async (data) => {
        this.dateDropdownData = data;
        this.selectedDropDownValue =
          this.dateDropdownData.find(
            (date) => date.monthYear === this.selectedDropDownValue?.monthYear,
          ) || this.dateDropdownData[0];
        this.selectedGroupCompositeId =
          this.selectedDropDownValue?.groupCompositeId || null;
        if (!this.keyGraphDateDropDownData.length)
          await this.KeyGraphDropdownData();
      });
    await this.globalService.fetchDateDropdownData();
    await this.KeyGraphDropdownData();

    this.tempSelectedList = [...this.selectedList];
  }

  openCommentsPanel() {
    this.commentService.setTitle('Key Graph Messages');
    this.commentService.setType('Key Graph');
    this.commentService.setSubhect('');
    this.commentService.setEnableAddComment(true);
    this.commentService.setOpenCommentsPanel(true);
  }

  onResetFilters() {
    this.selectedDropDownValue = this.dateDropDownData[0];
    this.selectedGroupCompositeId =
      this.selectedDropDownValue?.groupCompositeId || null;
    this.selectedCharts = [this.keyGraphDateDropDownData[0]];
    this.LoadKeyGraphData();
  }

  async onDateChange(selectedValue: any) {
    this.selectedDropDownValue = selectedValue;
    if (selectedValue) {
      this.selectedGroupCompositeId = selectedValue.groupCompositeId;
      await this.KeyGraphDropdownData();
    }
  }

  private createkeygraphRequest(): keygraphRequest {
    return {
      groupCompositeId: this.selectedGroupCompositeId || 0,
      selectedChartList: this.selectedCharts.map((item) => item?.chartId),
    };
  }

  public async LoadKeyGraphData() {
    if (!this.selectedCharts.length) return;
    this.resetErrorPage();
    this.globalService.updateShowOverlaySpinner(true);
    this.isLoading = true;
    this.showNoData = false;
    try {
      this.dataChamged = false;
      const addcustomRequest: keygraphRequest = this.createkeygraphRequest();
      const response: any =
        await this.keyGraphService.getKeyGraphData(addcustomRequest);
      if (response.statusCode !== 200) {
        this.setErrorPage(response.statusCode);
      } else if (!response?.data?.chartDetails?.length) {
        this.keygraphData = [];
        this.showNoData = this.keygraphData.length === 0;
        this.setErrorPage(204);
      } else {
        this.keygraphData = response.data.chartDetails;
        this.showNoData = this.keygraphData.length === 0;
      }
    } catch (error: any) {
      console.error('Error adding custom Group:', error);
      this.setErrorPage(error.status || error.statusCode);
    } finally {
      this.globalService.updateShowOverlaySpinner(false);
      this.isLoading = false;
      this.showNoData = true;
      this.dataChamged = true;
      this.cdr.detectChanges();
    }
  }

  async KeyGraphDropdownData() {
    this.keyGraphDateDropDownData = [];
    this.keygraphData = [];
    if (!this.selectedGroupCompositeId) return;
    this.resetErrorPage();
    this.globalService.updateShowOverlaySpinner(true);
    const response: any = await this.keyGraphService.getKeyGraphDropdownData({
      SelectedPeriod: this.selectedGroupCompositeId,
    });
    this.globalService.updateShowOverlaySpinner(false);
    if (response.statusCode !== 200) {
      this.setErrorPage(response.statusCode);
    } else if (!response.data.drowdownValues.length) {
      this.keyGraphDateDropDownData = [];
      this.setErrorPage(204);
    } else {
      this.keyGraphDateDropDownData = response.data.drowdownValues;
      if (this.selectedCharts.length) {
        this.selectedCharts = this.keyGraphDateDropDownData.filter((chart) =>
          this.selectedCharts.some(
            (dropdown) => dropdown.chartDesc === chart.chartDesc,
          ),
        );
      }
      if (!this.selectedCharts.length) {
        this.selectedCharts.push(this.keyGraphDateDropDownData[0]);
      }
      this.LoadKeyGraphData();
    }
    this.cdr.detectChanges();
  }

  getLabelshArray(chartData: any): string[] {
    return chartData.map((item: any) => item.nickName);
  }

  getChartData(chartData: any, index: string): number[] {
    return chartData.map((item: any) =>
      Number(item[index]?.split(',')?.join('')),
    );
  }

  onSelectionChange(event: any) {
    this.selectedCharts = [...event];
    this.LoadKeyGraphData();
  }

  ngOnDestroy(): void {
    this.globalService.setActiveComponent(null);
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  openPopup(mode: 'excel' | 'pdf') {
    this.mode = mode;
    this.showExcelPdfPopUp = true;
  }

  closePopup() {
    this.showExcelPdfPopUp = false;
  }

  async handlePrimaryButtonClick(event: PdfButtonClickedEvent) {
    if (!event.selectedOptions.length) {
      return;
    }
    this.selectedOptions = event.selectedOptions;
    this.isPageLayoutEnabled = event.isPageLayoutEnabled;
    if (event.mode === DownloadType.Pdf) {
      if (this.cdr) this.cdr.detectChanges();
      const mainDiv = await this.preparePdfContent(event);
      if (mainDiv) {
        const host = document.getElementById('pdf-render-host');
        host?.appendChild(mainDiv);

        const pdfBlob = await this.pdfViewerService.generatePdfFromBlocks(
          mainDiv,
          event.orientation?.toLowerCase() === 'landscape'
            ? 'landscape'
            : 'portrait',
          event.pageSize || 'A4',
          event.reportTitle,
          this.selectedDealer?.orgNickName ?? '',
        );

        if (pdfBlob) {
          this.globalService.showToast(
            'PDF report generated successfully.',
            'success',
          );
          this.pdfExcelPopup.isLoading = false;
          this.showExcelPdfPopUp = false;
          this.cdr.detectChanges();
          this.commentService.addLocalNotification({
            title: 'Report Generated',
            description: `Successfully generated PDF report for ${this.selectedDealer?.orgNickName}. Click on View PDF to view the report.`,
            type: 'Key-Graph',
            notificationId: new Date().toLocaleString(),
            createdDate: new Date().toLocaleString(),
            isRead: false,
            isServer: false,
            pdfUrl: URL.createObjectURL(pdfBlob),
          });
          this.pdfExportMessage =
            'PDF report generated successfully. You can download it from the notifications panel.';
        } else {
          this.globalService.showToast(
            'Failed to generate PDF report. Please try again.',
            'error',
          );
          this.pdfExcelPopup.isLoading = false;
          this.showExcelPdfPopUp = false;
          this.pdfExportMessage =
            'Failed to generate PDF report. Please try again.';
          this.cdr.detectChanges();
        }
      } else {
        this.pdfExportMessage =
          'Failed to generate PDF report. Please try again.';
      }
    }
    this.closePopup();
    if (event.mode === DownloadType.Pdf) {
      this.showPdfExportMessage = true;
      this.cdr.detectChanges();
    }
  }

  private prepareOffscreenNode(node: HTMLElement): HTMLElement {
    node.style.position = 'absolute';
    node.style.left = '-10000px';
    node.style.top = '0';
    node.style.visibility = 'visible';
    node.style.pointerEvents = 'none';
    return node;
  }

  private preparePdfContent(event: any): HTMLElement | null {
    document.getElementById('main-div')?.remove();
    const mainDiv = document.createElement('div');
    mainDiv.id = 'main-div';
    this.prepareOffscreenNode(mainDiv);
    const bannerDiv = this.pdfViewerService.createBannerContent(
      event.reportTitle,
    );
    if (!bannerDiv) return null;
    if (event.selectedOptions.includes('N20 Header')) {
      if (event.selectedOptions.includes('N20 Header')) {
        mainDiv.appendChild(
          this.pdfViewerService.createHeader(
            this.selectedDealer,
            bannerDiv,
            event.reportTitle,
          ),
        );
      }
    }
    if (event.selectedOptions.includes('Keygraph Chart')) {
      const filterDiv = this.pdfViewerService.FilterContent();
      filterDiv.innerHTML = `
      <div><b>Date:</b> ${this.selectedDropDownValue ? this.selectedDropDownValue.monthYear : 'N/A'}</div>`;
      filterDiv.id = 'filtersDiv';
      mainDiv.appendChild(filterDiv);
      const contentDiv = document
        .getElementById('pdf-table-content')
        ?.cloneNode(true) as HTMLElement;
      if (!contentDiv) {
        console.error('divDataTable not found!');
        return null;
      }
      contentDiv.id = 'contentDiv';
      contentDiv
        .querySelectorAll(
          '.search, .search-icon, input[type="text"], .icon-container, .td-icon',
        )
        .forEach((el) => el.remove());
      mainDiv.appendChild(contentDiv);
    }
    return mainDiv;
  }

  onShowPdf() {
    this.showPdfExportMessage = false;
    this.pdfExportMessage = '';
    this.commentService.setNotificationOpen(true);
  }
}
